import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    cardMainBox: {
      width: 330,
      height: 103.39,
      margin: 4,
      boxShadow: 'none',
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        width: 330,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.lg)]: {
        width: '96%',
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: '96.7%',
        marginLeft:0
      },
      "&:hover": {
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"

      }
    },
    MuiCardActionArea: {
      backgroundColor: '#fff'
    },
    actionArea: {
      textDecoration: 'none',
      color: 'black',
      "&:hover": {
        //backgroundColor: "grey"
      }
    },
    media: {
      height: 200,
      display: 'block',
      margin: 'auto auto',
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        height: 150,
      },
      //objectFit:'contain',
      //paddingTop: '56.25%'
    },
    priceText: {
      color: myTheme.palette.primary.main,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 18,
      },
    },
    titleText: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 15,
      },
    },
    categoryText: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 13,
      },
    },
    cutPriceText: {
      //marginLeft:16,
      textDecoration: 'line-through',
      color: "textSecondary",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: 15,
        marginLeft: 1
      },
    },
    productBtn: {
      // border: '0.1px',
      // borderColor:myTheme.palette.primary.light
    },
    ratingBox: {
      display: 'flex',
      flexDirection: 'column',
      '& > * + *': {
        marginTop: theme.spacing(1),
      },
    },
    ratingStars: {

    },
    pricesBox: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        display: 'flex',
        flexDirection: 'column'
      },
    }
  };
});

export default useStyles;
